import { render, staticRenderFns } from "./die-ord.vue?vue&type=template&id=baf16d82&scoped=true"
import script from "./die-ord.vue?vue&type=script&lang=js"
export * from "./die-ord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf16d82",
  null
  
)

export default component.exports